<!-- Issue Policy Steps -->
@if (hasValidData()) {
  <div>
    <div class="app__container py-6">
      <activar-stepper>
        @for (step of store.steps(); track step.id) {
          <activar-step 
            [id]="'step-' + step.id"
            [active]="step.active"
            [disabled]="step.disabled"
            [completed]="step.completed"
            (click)="!step.disabled && store.setCurrentStep(step.id)"
          >
            {{ step.name }}
          </activar-step>
        }
      </activar-stepper>
    </div>
  </div>
}

<!-- Issue Policy Content -->
@if (hasValidData()) {
  <div class="mt-8 px-5 flex flex-col justify-center items-center">
     
      @switch (store.currentStep()) {
        @case (1) {
          @if (user()) {
            <h2>Datos del tomador</h2>
            <app-user-data-step
              [user]="user()!"
              [loading]="loading()"
              (userUpdated)="updateUser($event)"
              (continueWithoutUpdate)="continueWithoutUpdate()"
            />
          }
        }
        @case (2) {
          @if (currentRiskType()) {
            <div class="md:w-2/4 w-full">
              <app-dynamic-risk-step2
                [riskType]="currentRiskType()!"
                [initialData]="step2InitialData()"
                (formDataChanged)="onStep2FormDataChanged($event)"
                (validationChanged)="onStep2ValidationChanged($event)"
                (componentReady)="onStep2ComponentReady($event)"
              />
              
              
            </div>
          } @else {
            <div class="bg-yellow-50 border border-yellow-200 rounded-md p-4">
              <p class="text-yellow-800">
                No se pudo determinar el tipo de riesgo. Por favor, verifique los datos.
              </p>
            </div>
          }
        }
        @case (3) {
          <div class="w-full max-w-4xl">
            <app-flow-resume-step
              [user]="user()"
              [insurableData]="insurableData()"
              [selectedCoverage]="selectedCoverage()"
              [additionalCoverage]="additionalCoverage()"
              [riskType]="riskType()"
              [quoteInfo]="quoteInfo()"
              [currency]="currency()"
              [detailComponentType]="detailComponentType()"
              [detailData]="detailData()"
              (referralCodeChanged)="onReferralCodeChanged($event)"
              (referralCodeValidating)="onReferralCodeValidating($event)"
              (clauseRemoved)="onClauseRemoved($event)"
            />
          </div>
          <div class="mt-6 flex justify-end gap-5 w-full max-w-4xl px-5">

            <activar-button
              color="primary"
              [disabled]="!canContinueFromResume()"
              (click)="goNext()"
              text="Continuar" />
          </div>

        }
        @case (4) {
          <div  class="md:w-2/4 w-full">
            <h2>Medio de pago</h2>
            <activar-card>
              <app-issue-policy-payment
                (paymentSelected)="setPaymentData($event)"
                (addingPaymentMethodChange)="isPaymentAddMode.set($event)"
              />
            </activar-card>
          </div>

          @if (emitting()) {
            <app-risk-loader subtitle="Emitiendo póliza..." />
          }

          @if (!isPaymentAddMode()) {
            <div class="mt-6 flex justify-end gap-5 md:w-2/4 w-full">
              <activar-button
                color="primary"
                fill="out"
                (click)="goBack()"
                [disabled]="emitting()"
              >
                Volver
              </activar-button>

              <activar-button
                color="primary"
                [loading]="emitting()"
                [disabled]="emitting()"
                (click)="confirmPolicy()"
              >
                @if (emitting()) {
                  Contratando...
                } @else {
                  Contratar
                }
              </activar-button>
            </div>
          }
        }
        @default {
          <p>Configurando pasos...</p>
        }
      }
    
  </div>
} @else {
  <app-risk-loader subtitle="Cargando cotización" />
}
